export enum SurveyResponseStateEnum {
  IN_PROGRESS = 'IN_PROGRESS',
  INTERRUPTED = 'INTERRUPTED',
  REFUSED = 'REFUSED',
  SUBMITTED = 'SUBMITTED',
}
